import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

type UseHashScrollProps = {
  elementsWithId: unknown[];
};

export default function useHashScroll({ elementsWithId }: UseHashScrollProps) {
  const { hash } = useLocation();

  useEffect(() => {
    if (!hash || elementsWithId.length === 0) return;

    document
      .getElementById(hash.slice(1)) // strip the leading '#'
      ?.scrollIntoView({ behavior: 'smooth' });
  }, [hash, elementsWithId.length]);
}
